/**
 * ActionCard — Displays a single proposed action from the agent
 */
import React from 'react';

const typeIcons = {
  relocation: '🔄',
  cycle_count: '📊',
  alert: '🔔',
  reslot: '📐',
  maintenance: '🔧',
  recount: '🔢',
  wave_replan: '🌊',
  equipment: '🚜',
  escalation: '📢',
  report: '📋',
  quality_fix: '✅',
  eot: '📅',
  hiring: '👷',
  procurement: '🛒'
};

const ActionCard = ({ action, index }) => {
  const icon = typeIcons[action.type] || '📌';

  return (
    <div className="bg-white border border-gray-200 rounded-lg p-3 shadow-sm hover:shadow-md transition-shadow">
      <div className="flex items-start gap-2">
        <span className="text-lg flex-shrink-0">{icon}</span>
        <div className="flex-1 min-w-0">
          <div className="flex items-center gap-2">
            <span className="text-xs font-mono text-gray-400">#{action.id || index + 1}</span>
            <span className="text-xs px-1.5 py-0.5 bg-blue-50 text-blue-600 rounded font-medium uppercase">
              {action.type?.replace('_', ' ')}
            </span>
          </div>
          <h4 className="font-semibold text-sm text-gray-900 mt-1">{action.title}</h4>
          <p className="text-xs text-gray-600 mt-0.5">{action.description}</p>
          {action.impact && (
            <p className="text-xs text-green-600 mt-1 flex items-center gap-1">
              <span>Impact:</span> {action.impact}
            </p>
          )}
          {action.estimated_time && (
            <p className="text-xs text-gray-400 mt-0.5">
              Est. time: {action.estimated_time}
            </p>
          )}
        </div>
      </div>
    </div>
  );
};

export default ActionCard;
